import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=6ca5ac55&scoped=true&"
import script from "./ServerList.vue?vue&type=script&lang=js&"
export * from "./ServerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5ac55",
  null
  
)

export default component.exports